/*
 * @Author: Zhanglei
 * @Date: 2020-07-09 09:24:09
 * @LastEditTime: 2020-07-21 10:26:17
 * @LastEditors: Zhanglei
 * @Description: In User Settings Edit
 * @FilePath: /desktop/src/languages/index.js
 */
import en from "./en";
import cn from "./zh-CN";

const massage = {
  en: en,
  "zh-CN": cn
};

export default massage;



// WEBPACK FOOTER //
// ./src/languages/index.js